import { CloseCircle, SearchIcon } from '@/assets/svg';
import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const useStyles = makeStyles({
  contained: {
    boxShadow: 'none',
  },
  head: {
    fontWeight: 600,
  },
});

const CustomSearchInput = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },

    '& input': {
      // minWidth: 335,
      minHeight: 40,
      padding: 0,
    },
  },
}))(TextField);

const OnePageTable = ({
  header: Header,
  renderRow,
  query = () => {},
  data = [],
  setSearchKey,
  searchKey,
  title = '',
  toolbar = true,
  ToolbarComponent,
  className,
  tableBody,
  footer: Footer,
  setData,
  stickyHeader,
  filterData,
  setFilterData,
}) => {
  const classes = useStyles();
  const onChangeSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const fetchData = async (search = searchKey) => {
    // query();

    const filteredData = data.filter((item) => {
      if (item.child) {
        for (const i in item.child) {
          return item.child[i].title
            .toLowerCase()
            .includes(search.toLowerCase());
        }
      } else {
        return item.title.toLowerCase().includes(search.toLowerCase());
      }
    });

    setFilterData(filteredData);
  };

  useEffect(() => {
    fetchData(searchKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey]);

  useEffect(() => {
    query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TableContainer>
      {/* Table toolbar */}
      <ToolsBar>
        <div style={{ display: 'flex' }} className={className}>
          <SearchWrapped>
            <CustomSearchInput
              variant="outlined"
              placeholder="Search"
              value={searchKey}
              onChange={onChangeSearch}
              fullWidth
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <IconButton
                        style={{
                          visibility: !isEmpty(searchKey)
                            ? 'visible'
                            : 'hidden',
                        }}
                        onClick={() => setSearchKey('')}
                      >
                        <CloseCircle
                          height={20}
                          width={20}
                          style={{
                            color: '#666666',
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  </>
                ),
              }}
            />
          </SearchWrapped>
          {ToolbarComponent}
        </div>
      </ToolsBar>
      <TableWrapped>
        <Table stickyHeader={stickyHeader}>
          {Header && <Header />}
          {tableBody ? (
            tableBody
          ) : (
            <TableBody>
              {(data || []).map((d, i) => (
                <TableRow
                  key={d.id}
                  hover
                  classes={{
                    head: classes.head,
                  }}
                >
                  {renderRow(d, i)}
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableWrapped>
      {Footer && <Footer />}
    </TableContainer>
  );
};

export default OnePageTable;

const ToolsBar = styled.div`
  .justify-between {
    justify-content: space-between;
  }
`;

const TableWrapped = styled.div`
  overflow: scroll;
  height: calc(75vh - 182px);
  margin-top: 40px;
`;

const SearchWrapped = styled.div`
  margin: 20px 5px 0px;
  width: 100%;
  border-style: solid;
  border-width: 0px;
  background: white;
  .ant-input-affix-wrapper {
    border: 0px;
  }
`;
